// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"652":"service","962":"home"}[chunkId] + "." + {"652":"4d23a732","962":"3a49a8d2"}[chunkId] + ".css";
};